<span
  class="counter {{ size }}"
  [ngClass]="{ 'h5-bold': size === 'small', 'h4-bold': size === 'large' }"
  >{{ count }}</span
>
